<template>
    <s-basic-slice class="s-tabs" v-bind="l10n">
        <a-tabs
            :theme="theme"
            :variant="variant"
            :with-icons="withIcons"
            :type-width="typeWidth"
            :no-top-spacing="noTopSpacing"
            :no-bottom-spacing="noBottomSpacing"
            :use-small-tabs="useSmallTabs"
            :radius="radius"
            :storage-key="storageKey"
        >
            <a-tab
                v-for="(slice, index) in l10n.slices"
                :key="index"
                :label="slice.label"
                :anchor-id="slice.anchorId"
                :event="slice.event"
            >
                <component
                    :is="getComponent(slice.name)"
                    class="s-tabs__item"
                    v-bind="slice.data"
                />
            </a-tab>
        </a-tabs>
    </s-basic-slice>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ATab from '@core/components/tabs/tab.vue';
import ATabs from '@core/components/tabs/tabs.vue';
import l10n from '@core/mixins/l10n.js';
import SBasicSlice from '@core/slices/pages/basic-slice/basic-slice.vue';
import { registerSlices } from '@utils/dynamic-slices-resolver';

export default defineComponent({
    name: 'STabs',

    components: {
        ATab,
        ATabs,
        SBasicSlice,
    },

    mixins: [l10n],

    inheritAttrs: false,

    props: {
        slices: {
            type: Array,
            default: () => [],
        },
        noTopSpacing: {
            type: Boolean,
            default: false,
        },
        noBottomSpacing: {
            type: Boolean,
            default: false,
        },
        useSmallTabs: {
            type: Boolean,
            default: false,
        },
        storageKey: {
            type: String,
            default: undefined,
        },
        variant: {
            type: Number,
            default: 1,
        },
        withIcons: {
            type: Boolean,
            default: false,
        },
        radius: {
            type: Number,
            default: 32,
        },
        theme: {
            type: String,
            default: 'light',
        },
        typeWidth: {
            type: String,
            default: undefined,
        },
    },

    data() {
        return {
            componentsRegistry: {},
        };
    },

    created() {
        /*
            This code is required here, because we had occurances of incorrect JSON structure passed via admin panel
            The example was when s-compete-page passed to s-tabs via awardsTabs object instead of slices array
            Our dynamic resolver requires the slice to be passing "slices" array and having { data, name } inside
            Not "awardsTabs": { "slices": [{ data, name }] }
            Other example was s-documentation trough side-menu, so we should remove this code only if we resolve all such cases.
        */
        registerSlices({
            pageBody: this.l10n?.slices || [],
            componentRegistrar: (name: string, component: any) => {
                this.componentsRegistry[name] = component;
            },
        });
    },

    methods: {
        getComponent(name: string) {
            return this.componentsRegistry[name] || null;
        },
    },
});
</script>

<style lang="pcss" scoped>
.s-tabs {
    &__item {
        padding: 0;
    }
}
</style>
